module.exports = __webpack_public_path__ + "img/ShareAlt.9afd3cdc.svg";